import * as React from 'react';
import { cn } from '@/lib/utils';
import { Skeleton } from '@/components/ui/skeleton';

export interface KpiDelta {
  /** Готовый текст: «+6% к вчера». */
  text: string;
  /** pos — рост (зелёный), neg — падение (красный), neutral — без оценки. */
  tone: 'pos' | 'neg' | 'neutral';
}

export interface KpiCardProps {
  label: React.ReactNode;
  value: React.ReactNode;
  /** Единица после числа мельче («сум»). */
  unit?: React.ReactNode;
  /** Изменение к прошлому периоду — только если его даёт API. */
  delta?: KpiDelta;
  /** Пояснение под числом без оценки («9,4% от всех пользователей»). */
  hint?: React.ReactNode;
  /** hero — тёмная карточка-акцент (одна на ряд, обычно выручка). */
  variant?: 'default' | 'hero';
  loading?: boolean;
  className?: string;
}

export function KpiCard({ label, value, unit, delta, hint, variant = 'default', loading, className }: KpiCardProps) {
  const hero = variant === 'hero';
  return (
    <div
      className={cn(
        'flex min-w-0 flex-col gap-2 rounded-card px-[18px] py-4',
        hero ? 'bg-hero text-on-hero' : 'border border-border-soft bg-surface text-text shadow-card',
        className,
      )}
    >
      <span className={cn('text-[13px]', hero ? 'text-on-hero-2' : 'text-text-2')}>{label}</span>
      {loading ? (
        <>
          <Skeleton className={cn('h-9 w-32', hero && 'bg-hero-track')} />
          <Skeleton className={cn('h-4 w-24', hero && 'bg-hero-track')} />
        </>
      ) : (
        <>
          <b className="font-display text-[30px] font-extrabold leading-tight tabular-nums">
            {value}
            {unit && <span className="ml-1.5 text-[15px] font-semibold">{unit}</span>}
          </b>
          {delta && (
            <span
              className={cn(
                'text-[13px] font-semibold',
                hero
                  ? delta.tone === 'neg' ? 'text-neg' : 'text-accent'
                  : delta.tone === 'pos' ? 'text-pos' : delta.tone === 'neg' ? 'text-neg' : 'text-text-2',
              )}
            >
              {delta.text}
            </span>
          )}
          {hint && <span className={cn('text-[13px]', hero ? 'text-on-hero-2' : 'text-text-2')}>{hint}</span>}
        </>
      )}
    </div>
  );
}
